var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_76_486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 22.5H6.1875C2.77566 22.5 0 19.7243 0 16.3125V6.1875C0 2.77566 2.77566 0 6.1875 0H16.3125C19.7243 0 22.5 2.77566 22.5 6.1875V16.3125C22.5 19.7243 19.7243 22.5 16.3125 22.5ZM6.1875 3C4.42987 3 3 4.42987 3 6.1875V16.3125C3 18.0701 4.42987 19.5 6.1875 19.5H16.3125C18.0701 19.5 19.5 18.0701 19.5 16.3125V6.1875C19.5 4.42987 18.0701 3 16.3125 3H6.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8125 22.5H31.6875C28.2757 22.5 25.5 19.7243 25.5 16.3125V6.1875C25.5 2.77566 28.2757 0 31.6875 0H41.8125C45.2243 0 48 2.77566 48 6.1875V16.3125C48 19.7243 45.2243 22.5 41.8125 22.5ZM31.6875 3C29.9299 3 28.5 4.42987 28.5 6.1875V16.3125C28.5 18.0701 29.9299 19.5 31.6875 19.5H41.8125C43.5701 19.5 45 18.0701 45 16.3125V6.1875C45 4.42987 43.5701 3 41.8125 3H31.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 48C30.5468 48 25.5 42.9533 25.5 36.75C25.5 30.5468 30.5468 25.5 36.75 25.5C42.9533 25.5 48 30.5468 48 36.75C48 42.9533 42.9533 48 36.75 48ZM36.75 28.5C32.201 28.5 28.5 32.201 28.5 36.75C28.5 41.299 32.201 45 36.75 45C41.299 45 45 41.299 45 36.75C45 32.201 41.299 28.5 36.75 28.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 48H6.1875C2.77566 48 0 45.2243 0 41.8125V31.6875C0 28.2757 2.77566 25.5 6.1875 25.5H16.3125C19.7243 25.5 22.5 28.2757 22.5 31.6875V41.8125C22.5 45.2243 19.7243 48 16.3125 48ZM6.1875 28.5C4.42987 28.5 3 29.9299 3 31.6875V41.8125C3 43.5701 4.42987 45 6.1875 45H16.3125C18.0701 45 19.5 43.5701 19.5 41.8125V31.6875C19.5 29.9299 18.0701 28.5 16.3125 28.5H6.1875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageDashboardIcon);
export default __webpack_public_path__ + "static/media/manageDashboardIcon.852ac154016fa180de1825d916162d1b.svg";
export { ForwardRef as ReactComponent };